export { default as List } from 'employees/containers/EmployeesListContainer';
export { default as Form } from 'employees/containers/EmployeeFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/containers/index.js